import React from 'react'
const Player = () => {
  return <div className="ant-color">34343233333333</div>
}
export default Player
